import React, { ReactNode } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Typography } from '@agria/theme/src/components/typography/Typography';
import { NetworkProvider } from '@agria/theme/src/context/NetworkContext';

const StyledErrorBarWrapper = styled.div`
  ${({ theme: { layers } }) => css`
    position: sticky;
    top: 0;
    z-index: ${layers.stickyErrorBar};
  `};
`;

export const ErrorBarWrapper = ({ children }: { children: ReactNode }) => (
  <NetworkProvider>
    <StyledErrorBarWrapper>{children}</StyledErrorBarWrapper>
  </NetworkProvider>
);

interface ErrorBarProps {
  message?: ReactNode;
  icon?: ReactNode;
  display?: boolean; // John doesn't like this name but it matches FormError. "shown" or "visible" would be better.
}

const StyledErrorBar = styled.div`
  ${({ theme: { colors, media, space } }) => css`
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 0.5s;
    background: ${colors.systemError20};
    overflow: clip;

    &[aria-hidden='true'] {
      grid-template-rows: 0fr;
    }

    > div {
      min-height: 0;
      max-width: 1120px;
      width: 100%;
      margin-inline: auto;
    }

    > div > div {
      display: flex;
      gap: ${space.xxSmall};
      align-items: start;
      padding-block: ${space.small};
      text-wrap: balance;
      padding-inline: ${space.fluidxSmallToXLarge};

      @media (min-width: ${media.medium}) {
        padding-inline: calc(${space.large} + ${space.large});
      }

      @media (min-width: ${media.large}) {
        justify-content: center;
        text-align: center;
      }
    }
  `};
`;

export const ErrorBar = ({ message, icon, display }: ErrorBarProps) => (
  <StyledErrorBar aria-hidden={!display} role="alert">
    <div>
      <div>
        {icon}
        <Typography component="span">{message}</Typography>
      </div>
    </div>
  </StyledErrorBar>
);
